import i18n from '@/lang/i18n'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { caseTypeValidationSituationConfigurationServices } from '@/modules/configurationModule/detail/local-cases/local-case-validation-situations/services/local-case-validation-situations.service'
import { store } from '@/store/store'
import { ConfigurationCaseValidationSituationConfigurationResponse } from '@/modules/configurationModule/detail/local-cases/local-case-validation-situations/services/local-case-validation-situations.dto'

export const columnsDefTextLocalCaseValidationSituationsGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.situation'),
            colId: 'validationSituation',
            field: 'validationSituation.translatedName',
            minWidth: 400,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.actionType'),
            colId: 'validationAction',
            field: 'validationAction.translatedName',
            minWidth: 400,
            flex: 1,
            suppressSizeToFit: true
        }
    ]

export interface LocalCaseValidationSituationsGridState extends CrudModelPaginatorLaboratory<ConfigurationCaseValidationSituationConfigurationResponse> {
    labId: number
}
export const initialLocalCaseValidationSituationsGridState =
    (): LocalCaseValidationSituationsGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.caseTypes.validationSituation',
        columnsDef: columnsDefTextLocalCaseValidationSituationsGrid(),
        datasource: new PaginatorLaboratoryDatasource(caseTypeValidationSituationConfigurationServices, store.getters.labId),
        labId: store.getters.labId
    })
